<template>
  <div class="homeNotice container-fluid position-relative d-flex mx-auto flex-column">
    <div class="announcement-wrapper" ref="announcementWrapper">        
        <transition-group name="scroll" tag="div" class="announcement-list">
            <div v-for="(announcement, index) in visibleAnnouncements" :key="index" class="announcement-item">
                <span class="announcement-title"><a :href="announcement.source" target="_blank">{{ announcement.title }}</a></span>
                <span class="announcement-date">({{ formatDate(announcement.updated_at) }})</span>
            </div>
        </transition-group>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TronAnnouncements",
  data() {
    return {
      announcements: [],
      visibleAnnouncements: [],
      currentIndex: 0,
      intervalId: null,
    };
  },
  async mounted() {
    await this.fetchAnnouncements();
    this.startAutoScroll();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    async fetchAnnouncements() {
      try {
        
        const response = await axios.get("/announcements.json");

        this.announcements = response.data.articles;
        this.visibleAnnouncements = [this.announcements[0]];
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    },
    startAutoScroll() {
      this.intervalId = setInterval(() => {
        this.scrollAnnouncements();
      }, 6000);
    },
    scrollAnnouncements() {
      this.currentIndex++;
      if (this.currentIndex >= this.announcements.length) {
        this.currentIndex = 0;
      }
      this.visibleAnnouncements = [this.announcements[this.currentIndex]];
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.announcement-container {  
  width: calc(100% - 24px); 
  /* max-width: 100vw; */
  min-width: 300px; 
  height: auto;
  overflow: hidden;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    
  margin: 24px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  
}

.announcement-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.announcement-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.announcement-item {
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: #333;
  //padding: 5px 0;
  transition: transform 0.5s ease-in-out;
}

.announcement-title {
  color: #ff6600;
  margin-right: 5px;
}

.announcement-date {
  color: #777;
  font-size: 11px;
}

/* Scroll Effect */
.scroll-enter-active,
.scroll-leave-active {
  transition: transform 0.5s ease-in-out;
}

.scroll-enter-from {
  transform: translateY(100%);
}

.scroll-leave-to {
  transform: translateY(-100%);
}
</style>
